import {
  EXTERNAL_SERVICE_CODE,
  ExternalServiceCodeType,
} from "types/externalService";

export type ConsumablePart = {
  type: ConsumablePartType;
  usage: number;
  max: number;
  unit: string;
  order: number;
};

export const CONSUMABLE_PART_TYPE = {
  mainBrush: "mainBrush",
  sideBrush: "sideBrush",
  filter: "filter",
  mopPad: "mopPad",
  dustBag: "dustBag",
} as const;

export type ConsumablePartType =
  (typeof CONSUMABLE_PART_TYPE)[keyof typeof CONSUMABLE_PART_TYPE];

/**
 * 入力値を ConsumalbePartType に変換する。不正な値の場合 undefined を返す
 */
export const parseConsumablePartType = (
  value: string
): ConsumablePartType | undefined => {
  const values = Object.values(CONSUMABLE_PART_TYPE);
  return values.includes(value as ConsumablePartType)
    ? (value as ConsumablePartType)
    : undefined;
};

const CONSUMABLE_PART_TYPE_LABEL: Record<ConsumablePartType, string> = {
  mainBrush: "メインブラシ",
  sideBrush: "サイドブラシ",
  filter: "フィルター",
  mopPad: "モップパッド",
  dustBag: "紙バック",
};

/**
 * 指定された partType から表示用のラベルを取得する
 */
export const getConsumablePartTypeDisplayLabel = (
  partType: ConsumablePartType,
  _exSrvCode: ExternalServiceCodeType
): string => {
  return CONSUMABLE_PART_TYPE_LABEL[partType] ?? partType;
};

/**
 * 指定された partType, usage, max から表示用のラベルを取得する
 */
export const getConsumablePartValueDisplayLabel = (
  partType: ConsumablePartType,
  usage: number,
  max: number,
  exSrvCode: ExternalServiceCodeType
): string => {
  const diff = Math.max(0, max - usage);

  switch (exSrvCode) {
    case EXTERNAL_SERVICE_CODE.TUYA:
      switch (partType) {
        case CONSUMABLE_PART_TYPE.mainBrush:
        case CONSUMABLE_PART_TYPE.sideBrush:
        case CONSUMABLE_PART_TYPE.filter:
          return `残 ${Math.floor(diff / 3600)} 時間`;
        default:
          return "-";
      }
    case EXTERNAL_SERVICE_CODE.DREAME:
      switch (partType) {
        case CONSUMABLE_PART_TYPE.mainBrush:
        case CONSUMABLE_PART_TYPE.sideBrush:
        case CONSUMABLE_PART_TYPE.filter:
          return `残 ${Math.floor(diff / 3600)} 時間`;
        case CONSUMABLE_PART_TYPE.mopPad:
        case CONSUMABLE_PART_TYPE.dustBag:
          return `残 ${diff} 日`;
        default:
          return "-";
      }
    default:
      return "-";
  }
};
